import React from 'react'
import { useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import CssBaseline from '@material-ui/core/CssBaseline'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Box, Typography } from '@material-ui/core'
import { UserContext } from '../../context api/UserContext'
import moment from 'moment'
import { useHistory } from 'react-router'
import { ROUTES } from '../../shared/constants'

import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import CustomCollapse from '../CustomCollapse'
import { getMenuItems } from '../../utils/menuItems'

const drawerWidth = 233

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    background: 'lightblue',
  },
  drawerOpen: {
    width: drawerWidth,
    background: '#EFF3FE',
    '& ::-webkit-scrollbar': {
      width: '0',
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    background: '#F6F8FE',
    width: '73px',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '& ::-webkit-scrollbar': {
      width: '0',
    },
    overflowX: 'hidden',
    // width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginTop: '15vh',

    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: 'lightblue',
  },
  profile: {
    display: 'flex',
    margin: '43px auto 15px auto',
    marginTop: '43px',
    marginBottom: '10px',
    width: '150px',
    height: '150px',
    [theme.breakpoints.up('lg')]: {
      width: '100px',
      height: '100px',
    },
  },
  heading: {
    display: 'flex',
    justifyContent: 'center',
    height: '30px',
  },
  image: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  text: {
    fontSize: '14px !important',
    fontWeight: 'normal !important',
  },
  selected: {
    background: 'white',
    color: '#33499F',
    padding: '10px',
    borderRadius: '10px',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  hovering: {
    '&:hover': {
      textDecoration: 'none',
      color: 'black',
      background: 'white',
    },
  },

  '@global': {
    '.MuiPaper-root': {
      borderRight: 'none !important',
    },
  },
  large: {
    width: '90px',
    height: '90px',
  },
  logo: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}))

export default function Sidebar({ open, handleOpen }) {
  const classes = useStyles()
  const history = useHistory()

  const user = useContext(UserContext)
  let permissions = []
  console.log(user.user)
  const userFeatures = user.user && user.user.allowedFeatures

  userFeatures &&
    userFeatures.forEach((val) => {
      permissions.push(val.module)
    })

  React.useEffect(() => {
    const pathName = window.location.pathname
    console.log(pathName)
    if (pathName === ROUTES.ALL_ATTENDANCE || pathName === ROUTES.LEAVE_REQUESTS || pathName === ROUTES.ALL_EMPLOYEES) {
      opens.attendance = true
      console.log('Manas', opens)
    } else if (pathName === ROUTES.CATEGORIES || pathName === ROUTES.SUBCATEGORIES || pathName === ROUTES.PRODUCTS || pathName === ROUTES.PRODUCT_CATALOGUE) {
      opens.product = true
    } else if (
      pathName === ROUTES.PRIMARY_SALES ||
      pathName === ROUTES.SALES_RETURN ||
      pathName === ROUTES.ALL_TARGETS ||
      pathName === ROUTES.INCENTIVE ||
      pathName === ROUTES.SALESDASHBOARD ||
      pathName === ROUTES.ACHIEVEMENT_REPORT
    ) {
      opens.sales = true
    } else if (pathName == ROUTES.CUSTOMERS || pathName === ROUTES.LEADS) {
      opens.lead = true
    } else if (pathName == ROUTES.ALL_TRAININGCATEGORY || pathName === ROUTES.ALL_TRAININGCATEGORYCONTENT || pathName === ROUTES.ALL_CONTENTQUESTION) {
      opens.learning = true
    } else if (pathName == ROUTES.ALL_AUDITQUESTION || pathName === ROUTES.ALL_TASK) {
      opens.audit = true
    }
  }, [])

  const [opens, setOpens] = useState({
    attendance: false,
    lead: false,
    sales: false,
    product: false,
    learning: false,
    audit: false,
  })

  const navItems = getMenuItems(user && user?.user?.userType.toUpperCase(), permissions)
  return (
    <div className={classes.root}>
      <CssBaseline />

      <Drawer
        variant="permanent"
        className={open ? classes.drawerOpen : classes.drawerClose}
        classes={{
          paper: open ? classes.drawerOpen : classes.drawerClose,
        }}
      >
        <Divider />
        <br />
        <div className={classes.profile}>
          {open && <img src={user && user.company && user.company.profilePicture} className={classes.logo} />}
          {/* <Avatar style={{ width: '90px', height: '90px' }} /> */}
          <br />
        </div>
        <br />
        {open && (
          <div className={classes.heading}>
            <h5> {user && user.company ? user.company.name || user.company.firstName : user.user.name}</h5>
          </div>
        )}
        {open && (
          <div className={classes.heading}>
            <p> Last Login : {moment(user && user.user.loginTime).format('h:mm a')}</p>
          </div>
        )}

        <br />
        <List>
          {navItems.map((val, index) => (
            <>
              {!val.display ? null : (
                <>
                  <Box
                    button
                    style={{ margin: '10px 20px', display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}
                    onClick={() => {
                      history.push(val.url)
                      !val.url && setOpens({ ...opens, [val.openNav]: !opens[val.openNav] })
                    }}
                    className={window.location.pathname === val.url ? `${classes.selected}` : ''}
                  >
                    <Box display="flex">
                      <val.icon style={{ fontSize: '1.5rem', marginRight: '10px' }} />

                      <Typography style={{ lineHeight: '20px', fontSize: '14px' }}>{val.label}</Typography>
                    </Box>

                    {val.subMenu && opens[val.openNav] ? (
                      <IoIosArrowUp
                        onClick={() => {
                          setOpens({ ...opens, [val.openNav]: !opens[val.openNav] })
                        }}
                      />
                    ) : (
                      val.subMenu && (
                        <IoIosArrowDown
                          onClick={() => {
                            setOpens({ ...opens, [val.openNav]: !opens[val.openNav] })
                          }}
                        />
                      )
                    )}
                  </Box>

                  <CustomCollapse open={opens[val.openNav]} collapseData={val.subMenu ? val.subMenu : []} handleClose={() => setOpens({ ...opens, [val.openNav]: false })} classes={classes} />
                  <Divider style={{ background: 'white' }} />
                </>
              )}
            </>
          ))}
        </List>
        <div className={classes.toolbar}>
          <IconButton onClick={handleOpen}>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</IconButton>
        </div>
      </Drawer>
    </div>
  )
}
